import { Pipe, PipeTransform } from '@angular/core';
import { DayjsDateUtilLibService } from '@b2b/date-util-lib';

@Pipe({
  name: 'withInDateRange',
  standalone: true,
})
export class WithinDateRangePipe implements PipeTransform {
  constructor(private dayjsDateUtilLibService: DayjsDateUtilLibService) {}

  transform(date: string | Date, numberOfDays: number): unknown {
    if (!date || !numberOfDays) {
      return false;
    }
    return this.dayjsDateUtilLibService.withInDateRange(
      new Date(date),
      new Date(),
      numberOfDays
    );
  }
}
